module.exports = __webpack_public_path__ + "media/src/assets/img/elements/ipad-pro-df7d34303f0e52c8ea7278f52c3b9826.png";